import { apiRequest } from "../util/apiUtils";

const run = async (payload) => {
  const res = await apiRequest("post", "runpod/run", {
    body: payload,
  });

  // Keep the HTTP status: a 409 means the book is already being drawn.
  return res?.data ? { ...res.data, httpStatus: res.status } : res?.data;
}

const warmup = async (payload, callTime = 1) => {
  // Create an array of requests (Promises) without awaiting them yet
  const requests = [];
  for (let i = 0; i < callTime; i++) {
    requests.push(
      apiRequest("post", "runpod/warmup", {
        body: { ...payload, _warmupIndex: i },
      })
    );
  }

  // Fire them all simultaneously!
  // This hits RunPod with 2 tickets at once, forcing 2 workers to wake up.
  await Promise.all(requests);
};

export { run, warmup }